import React, {memo} from 'react'
import styled from 'styled-components'

const VideoWrapper = styled.div`
  margin-top: 8px;
  video {
    width: 256px;
    height: 144px;
  }
`
const renderVideoMsg = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  return (
    <VideoWrapper>
      <video src={message.url} controls="controls"/>
    </VideoWrapper>
  )
})

export default renderVideoMsg
